<script>


export default {
  translate25Context: "home24",
  methods: {},
  props: ["component", "handler"],
  computed: {
    orderedLeft() {
      return Object.values(this.component.left).sort((a, b) => {
        return a.weight - b.weight;
      });
    },
  },
  data: function () {
    return {};
  },
};
</script>

<template>
  <div class="home24">
    <f-sexy-scroll>
      <div class="home24-content">
        <h2>{{ $vt('Welcome') }}</h2>
        <div class="home24-columns">
          <div class="home24-left home24-column">
            <div v-for="left in orderedLeft" :key="left['#id']">
              <vue-placeholder
                :component="left"
                :handler="handler"
              ></vue-placeholder>
            </div>
          </div>
          <div class="home24-right home24-column">
            <div v-for="right in component.right" :key="right['#id']">
              <vue-placeholder
                :component="right"
                :handler="handler"
              ></vue-placeholder>
            </div>
          </div>
        </div>
      </div>
    </f-sexy-scroll>
  </div>
</template>
<style lang="scss">
.home24 {
  height: 100%;
  display: flex;
  flex-direction: column;

  .f-sexy-scroll {
    height: 0;
    flex: 1 1 auto;
  }

  .home24-content {
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 48px;
  }

  h2 {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 64px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%; /* 70.4px */
  }
  .home24-columns {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 48px;

    .home24-column {
      display: flex;
      flex-direction: column;
      flex: 0 0 480px;
      width: 480px;
      gap: 24px;
    }
  }
}
.home24-box {
  border-radius: 6px;
  background: var(--white-a10);
  padding: 16px;
  border-left: 6px solid var(--primary);
}
</style>